import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import GlobalContextProvider from "./src/context/global-context-provider";

/* This file used to replace Gatsby's hydration with createRoot().render(), which throws
 * the server-rendered HTML away and builds the whole page again on the client. Until
 * that finished (several seconds on a slow phone) the page was blank apart from the
 * header. Hydrate the server HTML instead, and let the browser paint it first: a
 * hydration is one long task that would otherwise delay the first paint. The timeout
 * covers background tabs, where requestAnimationFrame never fires. */
const afterFirstPaint = () =>
  Promise.race([
    new Promise((resolve) =>
      requestAnimationFrame(() => setTimeout(resolve, 0))
    ),
    new Promise((resolve) => setTimeout(resolve, 300)),
  ]);

export const replaceHydrateFunction = () => (element, container) => {
  const trimSlashes = (path = "") => path.replace(/\/+$/, "");
  const hasServerHtml = !!document.getElementById("gatsby-focus-wrapper")
    ?.children.length;
  // Client-only routes are served the HTML of another page (the 404 page, or /app/),
  // which would not match what the client renders for the actual URL.
  const servesOwnHtml =
    trimSlashes(window.pagePath) === trimSlashes(window.location.pathname);

  if (!hasServerHtml || !servesOwnHtml) {
    // Nothing (matching) to hydrate
    createRoot(container).render(element);
    return;
  }

  afterFirstPaint().then(() => {
    hydrateRoot(container, element);
  });
};

export const wrapRootElement = ({ element }) => {
  return <GlobalContextProvider>{element}</GlobalContextProvider>;
};
